/**
 * Agents — everything about how an agent runs and what it starts from.
 *
 * A shell, not a panel: it owns the page container and composes sections that
 * each still live with their own logic. This is where five former destinations
 * land — Workflow (orchestration + context), Threads, Composer, Chat and
 * Editor — none of which held more than a handful of rows on its own.
 *
 * Each section carries an anchor id so the retired routes can redirect to the
 * row a user was actually looking for rather than to the top of the page.
 *
 * @module
 */
import { AgentContextSection } from "./AgentContextPanel";
import { AgentOrchestrationSection } from "./AgentOrchestrationPanel";
import { ChatSection } from "./ChatSection";
import { ComposerSettingsSection } from "./ComposerSettingsPanel";
import { EditorSection } from "./EditorSection";
import { SettingsPageContainer } from "./settingsLayout";
import { ThreadsSection } from "./ThreadsSection";

export function AgentsSettings() {
  return (
    <SettingsPageContainer>
      <AgentOrchestrationSection />
      <AgentContextSection />
      <ThreadsSection />
      <ChatSection />
      <ComposerSettingsSection />
      <EditorSection />
    </SettingsPageContainer>
  );
}
